export const agenda = {
  agendaDuration: 'тривалість',
  agendaCurtainCopy: 'Скопіювати посилання',
  agendaCurtainFlag: 'Поскаржитись',
  agendaCurtainFlagSent: 'Скаргу надіслано',
  agendaLinkCopied: 'Посилання скопійоване!',
  agendaStartsAt: 'Починається у ',
  agendaEndsAt: 'Закінчується у ',
  agendaSpeakers: 'Спікери',
  agendaSeeAllSpeakers: 'Усі',
  agendaAddToSchedule: 'Додати до мого розкладу',
  agendaRemoveFromSchedule: 'Прибрати з мого розкладу',
  agendaAddedToSchedule: 'Додано до мого розкладу!',
  agendaRemovedFromSchedule: 'Прибрано з мого розкладу!',
  agendaCalendar: 'Календар',
  agendaAddToCalendar: 'Додати в системний календар?',
  agendaCalendarSkip: 'Пропустити',
  agendaCalendarAdd: 'Додати',
  agendaNow: 'ЗАРАЗ',
  agendaModerators: 'Модератори',

  QnATitle: 'Запитання спікерам',
  askASpeaker: 'Задати питання',
  askAQuestion: 'Задати питання',
  askQuestionPlaceholder: 'Напишіть ваше питання',
  cancel: 'Скасувати',
  ask: 'Запитати',
  deleteConfirmation: 'Ви хочете видалити це запитання?',
  questionDeleted: 'Запитання успішно видалено!',
  rateSession: 'Оцініть цю сесію'
}
